export const planFeatures = {
  standard_free: [
    "Team -1",
    "Scheduling - 1 Daily (no recurring )",
    "Route Map Tracking",
    "Live Location Tracking - 5 employees",
    "Timesheets - Daily and Weekly",
    "Timesheets Approval",
    "Payroll - Weekly",
    "Members - 100",
    "Integrations",
    "Reporting",
  ],

  elite_free: [
    "Customers - unlimited",
    "Projects - unlimited",
    "Jobs - 1 daily",
    "Job Approval",
    "Photo, Audio Evidence Upload",
    "Invoicing - unlimited",
    "Job Notes - unlimited",
  ],

  standard: [
    "Dashboard",
    "Office",
    "Scheduling",
    "Route Map Tracking",
    "Live Location Tracking",
    "Timesheets",
    "Timesheets Approval",
    "Payroll",
    "Members",
    "Integrations",
    "Reporting",
  ],
  elite: [
    "Customers",
    "Projects",
    "Jobs",
    "Job Approval",
    "Photo Evidence Upload",
    "Audio Evidence Recording",
    "Job Notes - Unlimited",
  ],
};

export const PlanPrice = {
  standard_free: 0,
  elite_free: 0,
  standard_mon: 15,
  standard_ann: 9,
  elite_mon: 20,
  elite_ann: 12,
}

